import React from "react";
import { AppProvider } from "../context/EditSessionsContext";
import Layout from "../../../../common/layout/Layout";
import EditSessionLayout from "./EditSessionLayout";

const EditSessions: React.FC = () => {
  return (
    <Layout contextSearch>
      <AppProvider>
        <EditSessionLayout />
      </AppProvider>
    </Layout>
  );
};

export default EditSessions;
